<script setup lang="ts">
import { useHead } from '@unhead/vue'
import FilestackService from '../services/FilestackService'

// HEADER
useHead({
  title: 'ISO Certification ISO 9001:2015',
  meta: [
    {
      name: 'description',
      content: 'Wholesale distribution of Pressure/Temp Instrumentation'
    }
  ]
})
</script>

<template>
  <section class="p-2 lg:p-6 surface-section border-round">
    <div class="grid">
      <div class="col-12 text-center">
        <h1 class="text-3xl md:text-5xl text-red-500 font-medium m-0 p-0">
          Daughtridge Sales ISO Certification ISO 9001:2015
        </h1>
      </div>
      <div class="col-12 text-center">
        <div class="p-2">
          <img
            alt="Scanned image of Daughtridge Sales IS) 9001-2015 certificate from 2022"
            class="w-full"
            src="/images/Daughtridge Sales Co Inc - ISO 90012015 2028 Cert.jpg"
          >
        </div>
        <a
          class="p-button hover:bg-primary-600 text-decoration-none font-bold mb-2 md:mr-2"
          :href="FilestackService.publicReadUrl('vcRTs52tToqSOwp2T0rW')"
          target="_blank"
        >
          Download ISO Certification
        </a>
      </div>
    </div>
  </section>
</template>
